import t from '@instructure/quiz-i18n/es/format-message';
export function numericMessage(type) {
  return t('{type} must be a number', {
    type: type
  });
}
export function presenceMessage(type) {
  return t('{type} cannot be blank', {
    type: type
  });
}
export function noDuplicatesMessage(type) {
  return t('{type} cannot be duplicated', {
    type: type
  });
}